// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"lE-z","expressButtonContainerWithPayPal":"mE-z","expressButton":"nE-z","or":"oE-z"};